module.exports = __webpack_public_path__ + "res/img/gift.e0d42d18.png";